/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { ListUserInfo, ListItemButton } from '@components/molecules'

import { blue } from '@mui/material/colors'

import { User, UserType } from '@schemas'

interface PropsType {
	user?: UserType
	isChecked?: boolean
	chechedStyle?: React.CSSProperties
	onUserClick?: (aUser: UserType) => void
	showDepartmentName?: boolean
	userInfoStyle?: React.CSSProperties
	userInfoClassName?: string
	userInfoLeftAccessory?: (aUser: UserType) => JSX.Element
	children?: JSX.Element
}

export const UserListItem = (props: PropsType) => {
	const user = props.user ?? new User({})
	const showDepartmentName = props.showDepartmentName ?? false

	const RenderUserFrame = ({ children }: { children: React.ReactNode }) => {
		return (
			<View css={style}>
				{props.onUserClick !== undefined ? (
					<ListItemButton
						css={[
							{ marginBottom: '0.1rem' },
							props.userInfoStyle && { ...props.userInfoStyle },
							props.isChecked && props.chechedStyle
								? { ...props.chechedStyle }
								: props.isChecked
								? { color: blue[700] }
								: null,
						]}
						className={`listItem ${
							props.userInfoClassName ? props.userInfoClassName : ''
						} ${props.isChecked ? 'checked' : ''}`}
						onClick={() => {
							if (props.onUserClick) {
								props.onUserClick(user)
							}
						}}
					>
						{children}
					</ListItemButton>
				) : (
					<View
						css={[
							{ marginBottom: '0.1rem' },
							props.userInfoStyle ? { ...props.userInfoStyle } : {},
						]}
						className={`listItem view ${
							props.userInfoClassName ? props.userInfoClassName : ''
						} ${props.isChecked ? 'checked' : ''}`}
					>
						{children}
					</View>
				)}
			</View>
		)
		// }
	}

	const LeftAccessory = () => {
		return <>{props.userInfoLeftAccessory ? props.userInfoLeftAccessory(user) : null}</>
	}

	return (
		<RenderUserFrame>
			{props.children ? (
				<>{props.children}</>
			) : (
				<ListUserInfo
					user={user}
					isChecked={props.isChecked}
					showDepartmentName={showDepartmentName}
				/>
			)}
			<LeftAccessory />
		</RenderUserFrame>
	)
}

const style = css({
	'.listItem': {
		paddingLeft: '2rem',
		borderRadius: '5px',

		'&.view': {
			padding: '0.5rem 2rem',
			textAlign: 'left',
		},

		'&.checked': {
			background: '#f1f9ff',
		},
	},
})
